import { taskStatusList } from 'json/production-task'
export let filterLabels = [{
  label: '实验人员',
  slotName: 'labTester'
}, {
  label: '状态',
  type: 'select',
  clearable: true,
  value: 'status',
  options: taskStatusList
}, {
  label: '开始日期',
  type: 'date',
  clearable: true,
  value: 'startTime' // 需返回数据的字段名
}, {
  label: '结束日期',
  type: 'date',
  clearable: true,
  value: 'endTime' // 需返回数据的字段名
}, {
  label: '是否逾期',
  type: 'select',
  clearable: true,
  value: 'overDue', // 需返回数据的字段名
  options: [{
    label: '是',
    value: 'true'
  }, {
    label: '否',
    value: 'false'
  }]
}]

export const tableLabels = [{
    label: '任务单编号',
    value: 'serialNumber',
    minWidth: '120px'
  },
  {
    label: '所属委托单编号',
    value: 'billCode',
    minWidth: '150px'
  },
  {
    label: '实验人员',
    value: 'labTester.name',
    minWidth: '120px'
  },
  {
    label: '状态',
    slotName: 'status',
    minWidth: '160px'
  },
  {
    label: '开始日期',
    value: 'start_time',
    minWidth: '120px'
  },
  {
    label: '目标日期',
    value: 'end_time',
    minWidth: '120px'
  },
  {
    label: '检测项目名称',
    value: 'item_names',
    minWidth: '180px'
  },
  {
    label: '样品名称',
    value: 'orderNames',
    minWidth: '120px'
  },
  {
    label: '派单人',
    value: 'creator',
    minWidth: '120px'
  },
  {
    label: '派单日期',
    value: 'create_time',
    minWidth: '120px'
  },
  {
    label: '检测项目数量',
    value: 'examItemCount',
    minWidth: '120px'
  },
  {
    label: '指标数量',
    value: 'orderCount',
    minWidth: '120px'
  },
  {
    label: '样品数量',
    value: 'realSampleCount',
    minWidth: '120px'
  },
  {
    label: "交付方式",
    value: "delivery_type"
  },
  {
    label: '操作',
    slotName: 'operate',
    fixed: 'right',
    minWidth: '120px'
  }
]